import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import locationShape from 'react-router/lib/PropTypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Layout, MainContent, Sidebar } from '@bibliocommons/base-drawer';
import FieldList from '../../shared/Facets/FieldList';
import SearchResults from '../SearchResults';
import SearchTitle from '../SearchTitle';
import SearchScopeFieldContainer from '../../../containers/SearchScopeFieldContainer';
import MobileSearchBox from '../MobileSearchBox';

import SearchTitleDeprecated from '../SearchTitleDeprecated';
import FeatureFlagContainer from '../../../containers/FeatureFlagContainer';
import updateSearchQuery from '../../../helpers/search/updateSearchQuery';

class Search extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleExpandField', 'transformQueryForFieldList');
  }

  handleExpandField(value) {
    this.props.searchActions.expandField(value, this.props.router.location.query);
  }

  transformQueryForFieldList(query) {
    const { searchType, activeFilters, location } = this.props;
    return updateSearchQuery({
      currentQuery: location.query,
      activeFilters,
      ...query,
      searchType
    });
  }

  resultContentStatusClassName() {
    return this.props.resultPaneActive ? 'active' : 'inactive';
  }

  renderSearchBox() {
    const { orderedSearchTypes, locked, query, searchType, activeFilters } = this.props;
    return this.context.mobileApp && (
      <MobileSearchBox
        locked={locked}
        searchTypes={orderedSearchTypes}
        query={query}
        searchType={searchType}
        activeFilters={activeFilters} />
    );
  }

  renderSearchResults() {
    // values
    const { activeFilters,
      branches,
      currentView,
      groupedSearchEnabled,
      drawer,
      isFetching,
      featuredContent,
      featuredContentBlockPosition,
      fields,
      groupSearchFeedbackActions,
      libraryShortName,
      location,
      locked,
      pagination,
      results,
      rssURL,
      searchType,
      singleBranch,
      sortBys,
      ...otherProps } = this.props;

    // actions
    const { drawerActions, listPresentationActions, searchActions, didNotFindOptions, chatWidgets } = this.props;
    return (
      <Layout open={drawer.get('open')} containerClass="results_container">
        <Sidebar sidebarClass="results_fields" drawerActions={drawerActions}>
          <FieldList
            paginationField="pagination_page"
            fields={fields}
            drawerActions={drawerActions}
            activeFilters={activeFilters}
            singleBranch={singleBranch}
            renderSearchScope={() => (<SearchScopeFieldContainer />)}
            handleExpandField={this.handleExpandField}
            transformQuery={this.transformQueryForFieldList} />
        </Sidebar>
        <MainContent mainClass={`result-content ${this.resultContentStatusClassName()}`}>
          <SearchResults
            {...otherProps}
            activeFilters={activeFilters}
            branches={branches}
            currentUser={this.props.currentUser}
            currentView={currentView}
            groupedSearchEnabled={groupedSearchEnabled}
            isFetching={isFetching}
            featuredContent={featuredContent}
            featuredContentBlockPosition={featuredContentBlockPosition}
            groupSearchFeedbackActions={groupSearchFeedbackActions}
            libraryShortName={libraryShortName}
            listPresentationActions={listPresentationActions}
            location={location}
            locked={locked}
            pagination={pagination}
            results={results}
            rssURL={rssURL}
            searchActions={searchActions}
            searchType={searchType}
            singleBranch={singleBranch}
            sortBys={sortBys}
            didNotFindOptions={didNotFindOptions}
            chatWidgets={chatWidgets} />
        </MainContent>
      </Layout>
    );
  }

  renderSearchTitleDeprecated() {
    const { percent, query, searchType, broadened, didYouMeanQuerySuggestion, showExternalSearchLink, drawerActions,
      broadenedSearchType, broadenedSearchCount, didYouMeanResultCount, title, titleKey, suppress, customEdit } = this.props;

    return (
      <SearchTitleDeprecated
        broadened={broadened}
        broadenedSearchCount={broadenedSearchCount}
        broadenedSearchType={broadenedSearchType}
        customEdit={customEdit}
        didYouMeanQuerySuggestion={didYouMeanQuerySuggestion}
        didYouMeanResultCount={didYouMeanResultCount}
        drawerActions={drawerActions}
        id="searchTitle"
        percent={percent}
        query={query}
        searchType={searchType}
        showExternalSearchLink={showExternalSearchLink}
        suppress={suppress}
        title={title}
        titleKey={titleKey} />
    );
  }

  render() {
    const { percent, query, searchType, broadened, didYouMeanQuerySuggestion, showExternalSearchLink, drawerActions,
      broadenedSearchType, broadenedSearchCount, didYouMeanResultCount, title, titleKey, suppress, customEdit, rssURL, didNotFindOptions } = this.props;

    return (
      <div>
        {this.renderSearchBox()}
        <FeatureFlagContainer>
          {
            flags => flags.get('searchImprovements') ? (
              <SearchTitle
                broadened={broadened}
                broadenedSearchCount={broadenedSearchCount}
                broadenedSearchType={broadenedSearchType}
                customEdit={customEdit}
                didYouMeanQuerySuggestion={didYouMeanQuerySuggestion}
                didYouMeanResultCount={didYouMeanResultCount}
                drawerActions={drawerActions}
                id="searchTitle"
                percent={percent}
                query={query}
                searchType={searchType}
                showExternalSearchLink={showExternalSearchLink}
                suppress={suppress}
                title={title}
                titleKey={titleKey}
                rssURL={rssURL}
                didNotFindOptions={didNotFindOptions} />
            ) : this.renderSearchTitleDeprecated()
          }
        </FeatureFlagContainer>
        { this.renderSearchResults() }
      </div>
    );
  }
}

Search.defaultProps = {
  currentView: 'medium'
};

Search.propTypes = {
  activeFilters:             ImmutablePropTypes.map.isRequired,
  branches:                  ImmutablePropTypes.list,
  broadened:                 PropTypes.bool,
  broadenedSearchCount:      PropTypes.number,
  broadenedSearchType:       PropTypes.string,
  catalogSearchOptions:      ImmutablePropTypes.map,
  currentUser:               ImmutablePropTypes.map,
  currentView:               PropTypes.string.isRequired,
  groupedSearchEnabled:      PropTypes.bool.isRequired,
  customEdit:                PropTypes.bool,
  didYouMeanQuerySuggestion: PropTypes.string,
  didYouMeanResultCount:     PropTypes.number,
  drawer:                    ImmutablePropTypes.map,
  drawerActions:             PropTypes.objectOf(PropTypes.func),
  featuredContent:           ImmutablePropTypes.map,
  featuredContentBlockPosition: PropTypes.number,
  fields:                    ImmutablePropTypes.list.isRequired,
  isFetching:                PropTypes.bool,
  libraryShortName:          PropTypes.string.isRequired,
  listPresentationActions:   PropTypes.objectOf(PropTypes.func).isRequired,
  location:                  PropTypes.shape(locationShape),
  locked:                    PropTypes.bool,
  pagination:                ImmutablePropTypes.map.isRequired,
  query:                     PropTypes.string.isRequired,
  resultPaneActive:          PropTypes.bool,
  results:                   ImmutablePropTypes.list.isRequired,
  rssURL:                    PropTypes.string,
  searchActions:          PropTypes.shape({
    betaSearch:           PropTypes.func,
    clearFilters:         PropTypes.func,
    closeExpandField:     PropTypes.func,
    expandField:          PropTypes.func
  }),
  searchType:                PropTypes.string.isRequired,
  showExternalSearchLink:    PropTypes.bool,
  singleBranch:              PropTypes.bool,
  sortBys:                   ImmutablePropTypes.list.isRequired,
  suppress:                  PropTypes.bool,
  title:                     PropTypes.string,
  titleKey:                  PropTypes.string,
  zeroResults:               PropTypes.bool.isRequired,
  searchTypes:               ImmutablePropTypes.list,
  didNotFindOptions:         ImmutablePropTypes.map,
  chatWidgets:               ImmutablePropTypes.mapOf(PropTypes.object)
};

Search.contextTypes = {
  mobileApp: PropTypes.bool
};


export default Search;



// WEBPACK FOOTER //
// ./app/components/search/Search/Search.jsx